function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.304 2c.372 0 .696.33.696.705V8.84c.005.38-.32.715-.696.715-.377 0-.702-.336-.697-.711V3.41H8.076l4.707 2.057c.252.11.423.372.422.649v11.577l2.402.011v-5.217c-.005-.379.32-.715.697-.715.376 0 .701.336.696.711v5.927c0 .375-.324.705-.697.705l-3.098-.013v2.709c-.006.473-.536.825-.97.638l-7.812-3.411c-.25-.108-.419-.365-.423-.642v-6.591c-.005-.379.32-.715.696-.715.377 0 .702.336.697.711v6.133l6.42 2.802V6.571l-6.42-2.802v6.21c.005.378-.32.714-.697.714-.376 0-.701-.336-.696-.711V2.706c-.001-.353.282-.671.63-.705L4.656 2h11.649zm3.736 5.997l2.542 2.045c.335.27.335.823 0 1.093l-2.54 2.044c-.294.238-.76.195-1.003-.093-.246-.291-.201-.757.096-.999l.984-.79h-5.373c-.379.017-.727-.295-.745-.672-.018-.377.3-.72.69-.737h5.431l-.984-.795c-.226-.176-.325-.485-.243-.757.083-.271.335-.474.618-.5.19-.018.385.042.527.161z",
  transform: "translate(-120 -539) translate(120 539)"
}))));

var SvgIconExit = function SvgIconExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-exit.bfee6ab1.svg";
export { ForwardRef as ReactComponent };